// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.splash-screen-header {
  padding-top: 40px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.header-action-buttons {
  position: relative;
}

.splash-screen-container {
  width: 100%;
  max-width: 485px;
  margin: 0 auto;
  padding-top: 60px;
}
.splash-screen-container .logo {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
}
.splash-screen-container .logo .focalx-logo {
  max-width: 240px;
}

.splash-screen-card {
  border: solid 1px #2E9FC4;
  border-radius: 32px;
  padding: 80px 40px;
  margin-top: 60px;
  text-align: center;
}
.splash-screen-card .form {
  max-width: 300px;
  margin: 0 auto;
}
.splash-screen-card .otp-input-container {
  margin-top: 60px;
  display: flex;
  justify-content: space-between;
}
.splash-screen-card .otp-input {
  width: 40px;
  height: 40px;
  border: solid 1px #009AC6;
  margin: 0 10px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.splash-screen-card .error-msg {
  padding-top: 10px;
}
.splash-screen-card .action-btn-wrap {
  margin-top: 60px;
}
.splash-screen-card .action-btn-wrap .custom-btn {
  width: 100%;
}

@media only screen and (min-width: 0px) and (max-width: 767px) {
  .splash-screen-container .logo .focalx-logo {
    max-width: 108px;
  }
  .splash-screen-header {
    padding-top: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/SplashScreen/SplashScreen.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AACJ;;AACA;EACI,kBAAA;AAEJ;;AAAA;EACI,WAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAGJ;AAFI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;AAIR;AAHQ;EACE,gBAAA;AAKV;;AAAA;EACI,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAGJ;AAFI;EACI,gBAAA;EACA,cAAA;AAIR;AAFI;EACI,gBAAA;EACA,aAAA;EACA,8BAAA;AAIR;AAFI;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAIR;AAFI;EACI,iBAAA;AAIR;AAFI;EACI,gBAAA;AAIR;AAHQ;EACI,WAAA;AAKZ;;AAAA;EAGY;IACE,gBAAA;EACZ;EAGE;IACI,iBAAA;EADN;AACF","sourcesContent":[".splash-screen-header{\r\n    padding-top: 40px;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    position: relative;\r\n}\r\n.header-action-buttons{\r\n    position: relative;\r\n}\r\n.splash-screen-container{\r\n    width: 100%;\r\n    max-width: 485px;\r\n    margin: 0 auto;\r\n    padding-top: 60px;\r\n    .logo{\r\n        display: flex;\r\n        align-items: center;\r\n        width: 100%;\r\n        justify-content: center;\r\n        .focalx-logo{\r\n          max-width: 240px;\r\n        }\r\n      }\r\n}\r\n\r\n.splash-screen-card{\r\n    border: solid 1px #2E9FC4;\r\n    border-radius: 32px;\r\n    padding: 80px 40px;\r\n    margin-top: 60px;\r\n    text-align: center;\r\n    .form{\r\n        max-width: 300px;\r\n        margin:  0 auto;\r\n    }\r\n    .otp-input-container{\r\n        margin-top: 60px;\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n    .otp-input{\r\n        width: 40px;\r\n        height: 40px;\r\n        border: solid 1px #009AC6;\r\n        margin: 0 10px;\r\n        border-radius: 8px;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        text-align: center;\r\n    }\r\n    .error-msg{\r\n        padding-top: 10px;\r\n    }\r\n    .action-btn-wrap{\r\n        margin-top: 60px;\r\n        .custom-btn{\r\n            width: 100%;\r\n        }\r\n    }\r\n}\r\n\r\n@media only screen and (min-width: 0px) and (max-width: 767px) {\r\n    .splash-screen-container{\r\n        .logo{\r\n            .focalx-logo{\r\n              max-width: 108px;\r\n            }\r\n          }\r\n    }\r\n    .splash-screen-header{\r\n        padding-top: 20px;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
